import { Icon } from 'deda-rkit';
import React from 'react';
import { Component, ReactNode } from 'react'


type State = {
    isVisible: boolean;
}

export default class ScrollTopButton extends Component<{}, State>{

    constructor(props) {

        super(props);
        this.state = {
            isVisible: false
        };

        this.onScroll = this.onScroll.bind(this);
        this.onClick = this.onClick.bind(this);
    }

    /* ------ handlers ------ */
    onScroll(e) {
        this.setState({
            isVisible: e.target.scrollingElement.scrollTop > 200
        })
    }

    onClick(e) {
        window.scrollTo(0, 0);
    }

    /* ------ lifecycle functions ------ */
    componentDidMount(): void {
        window.addEventListener('scroll', this.onScroll.bind(this));
    }

    componentWillUnmount(): void {
        window.removeEventListener('scroll', this.onScroll.bind(this));
    }

    render(): ReactNode {
        return (
            <a
                onClick={(e) => this.onClick(e)}
                className='fixed-bottom m-5'
                style={{
                    left: 'auto'
                }}
            >
                <Icon
                    icon='it-collapse'
                    color='white'
                    height={32}
                    width={32}
                    className={`${this.state.isVisible ? 'bg-primary' : 'd-none'} rounded-circle border border-white`}
                />
            </a>
        )
    }
}